<div class="container">
  <div class="meals-container">
    <img class="section-left-img" src="assets/brookly.png" alt="Brookly">
    <img class="section-right-img" src="assets/cherry-tomatoes.png" alt="Tomatoes">
    <img class="section-left-dot" src="assets/merchant-landing-page/rectangle-red-icon.png">
    <img class="section-right-dot" src="assets/merchant-landing-page/rectangle-yellow-icon.png">

    <div class="pre-head-section"><p class="section-pre-header" i18n>Discover Meals for Every Preference</p></div>
    <div class="meals-description-header">
      <h1 i18n>Your Taste, Your Way: Raw to Hot</h1>
    </div>
    <p class="meals-description" i18n>From the crispness of Raw salads to the comfort of Cooked classics and the hearty warmth of Hot meals, discover dishes that cater to every whim</p>
    <div class="meals-types-container">
      <div class="meal-item">
        <img src="assets/raw-food.svg" alt="raw">
        <p class="meal-item-title" i18n>Raw Delights</p>
        <p class="meal-item-desc" i18n>Fresh, uncooked delights.</p>
      </div>
      <div class="meal-item">
        <img src="assets/vegetables.svg" alt="cooked">
        <p class="meal-item-title" i18n>RoComforting Cooked</p>
        <p class="meal-item-desc" i18n>Gently preprated, full of flavor.</p>
      </div>
      <div class="meal-item">
        <img src="assets/cooked.svg" alt="hot">
        <p class="meal-item-title" i18n>Heartwarming Hot</p>
        <p class="meal-item-desc" i18n>Served steaming, for instant comfort.</p>
      </div>
    </div>
  </div>
</div>
